import { LitElement, html } from "lit";
import { customElement } from "lit/decorators.js";
import { localized, msg, str } from "@lit/localize";
import style from './menu-top-hamburger.scss';
import "../../icon";

/**
 * Left menu collapse button.
 */
@customElement('menu-top-hamburger')
@localized()
export class MenuTopHamburger extends LitElement {
    static override shadowRootOptions = { ...LitElement.shadowRootOptions, delegatesFocus: true };
    static override styles = style;

    toggleLeftMenu() {
        const mainPanel = document.querySelector('main-panel');
        if (!mainPanel) return;
        mainPanel.leftMenuHidden = !mainPanel.leftMenuHidden;

        /* below 880px, for usos-layout[responsive]: show menu-left on every click, unless it is already visible - then hide */
        const leftMenu = mainPanel.querySelector('menu-left');
        if (leftMenu && mainPanel.responsive && !this.isLeftMenuVisible()) {
            leftMenu.focus({ preventScroll: true });
        }
        this.requestUpdate();
    }

    override render() {
        const label = this.isLeftMenuVisible() ? msg(str`Ukryj menu boczne`) : msg(str`Pokaż menu boczne`);
        return html`
            <usos-icon id="hamburger" is-button icon-name="menu" .label=${label} @click=${this.toggleLeftMenu}></usos-icon>
        `
    }

    private isLeftMenuVisible() {
        const leftMenu = document.querySelector('main-panel menu-left');
        return leftMenu != null && leftMenu.getBoundingClientRect().right > 0;
    }
}

declare global {
    interface HTMLElementTagNameMap {
      "menu-top-hamburger": MenuTopHamburger,
    }
}
